/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { useMemo } from 'react';
import { Text, View } from 'react-native';
import type { SaleDetailDiscount } from '../domain/salesTypes';
import { summarizeSaleDetailDiscounts } from '../application/saleDetailPromotionPresentation';
import { formatMoney as formatPromoMoney } from '../../shared/format/public-api';
import { saleDetailStyles as styles } from './saleDetail.styles';

type Props = {
  discounts: SaleDetailDiscount[];
};

export function SaleDetailPromotionsSummary({ discounts }: Props) {
  const rows = useMemo(() => summarizeSaleDetailDiscounts(discounts), [discounts]);

  if (rows.length === 0) return null;

  return (
    <View style={styles.checkoutPromoSummaryBlock}>
      <Text style={styles.checkoutPromoSummaryTitle}>Promos</Text>
      {rows.map((discount) => (
        <View key={discount.id} style={styles.checkoutPromoSummaryRow}>
          <Text style={styles.checkoutPromoSummaryName}>{discount.promotionName}</Text>
          <Text style={styles.checkoutPromoSummaryMeta}>
            {discount.scopeLabel} · −{formatPromoMoney(discount.discountAmount)}
          </Text>
        </View>
      ))}
    </View>
  );
}
